import Lottie from 'lottie-react';

import faceTalkingConfused from '../jsons/Face_Talking_Confused.json';

const FaceTalkingConfused = props => {
  return <Lottie animationData={faceTalkingConfused} {...props} />;
};

export default FaceTalkingConfused;
